import * as React from "react";
const SvgFiRrFilms = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18 22a1 1 0 0 1-1 1H5c-2.757 0-5-2.243-5-5v-7.764C0 9.1.486 8.013 1.333 7.255a1 1 0 1 1 1.334 1.49c-.424.38-.667.923-.667 1.491V18c0 1.654 1.346 3 3 3h12a1 1 0 0 1 1 1m6-16.5v9c0 2.481-2.019 4.5-4.5 4.5h-10A4.505 4.505 0 0 1 5 14.5v-9C5 3.019 7.019 1 9.5 1h10C21.981 1 24 3.019 24 5.5M22 13v-2h-2v2zm-2-4h2V7h-2zm0-5.95V5h1.95A2.51 2.51 0 0 0 20 3.05M7 7v2h2V7zm0 6h2v-2H7zm.05-8H9V3.05A2.51 2.51 0 0 0 7.05 5M9 16.95V15H7.05c.199.978.972 1.75 1.95 1.95m9 .05V3h-7v14zm3.95-2H20v1.95A2.51 2.51 0 0 0 21.95 15"
    />
  </svg>
);
export default SvgFiRrFilms;
